import { render, staticRenderFns } from "./instructionPublic.vue?vue&type=template&id=b0b35af2&scoped=true"
import script from "./instructionPublic.vue?vue&type=script&lang=js"
export * from "./instructionPublic.vue?vue&type=script&lang=js"
import style0 from "./instructionPublic.vue?vue&type=style&index=0&id=b0b35af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b35af2",
  null
  
)

export default component.exports